// extracted by mini-css-extract-plugin
export default {"description":"style_description__vqJaR","fade-in":"style_fade-in__AWFBe","top":"style_top__jaC9+","image":"style_image__IkAlv"};